export { default as RecentOrderCardCarousel } from './recent-order-card-carousel';
